/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';

import Breadcrumb from '@js/components/Common/Breadcrumbs';

import ProductLightbox from './content/ProductLightbox';
// import AddFavorite from './content/AddFavorite';
import TabContent from './content/TabContent';
import Rating from './content/Rating';

// import ModalAnnounce from './modal/Announce';
import AddCartModal from './modal/AddtoCart';
import ApiExceptionModal from './modal/ApiExceptionModal';
// const ApiExceptionModal = React.lazy(() => import("./content/Modals/ApiExceptionModal"));

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCartModalShow: false,
      productAmount: 1,
      tabType: 'spec', // 默認為 商品描述
    };
  }

  componentDidMount() {
    const { getPrdPageBrandStyle, getProductData, updateRequestCatePath } = this.props;

    getPrdPageBrandStyle();
    getProductData();
    // SEOCatePath 是從 jsp 來的
    updateRequestCatePath(window.SEOCatePath);
  }

  componentDidUpdate(prevProps) {
    // 取得「你可能會喜歡」、門市貨況查詢
    const {
      product,
      // updateOtherAlsoLikeProduct,
      updateRequestProductCode,
    } = this.props;

    if (prevProps.product !== product) {
      updateRequestProductCode(product.rightTextInfo.sku);
      // getProductPageOtherAlsoLike(
      //   updateOtherAlsoLikeProduct,
      //   product.rightTextInfo.sku,
      //   ""
      // );
    }
  }

  /** 更改tab類型
   * spec：商品描述
   * logistic：送貨及付款方式
   * comment：顧客評價
   */
  setTabType = tabType => {
    this.setState({ tabType });
  };

  /** 關閉異常Modal */
  closeExceptionModal = () => {
    const {
      // func
      closeExceptionModal,
    } = this.props;

    closeExceptionModal();
    this.setState({ isCartModalShow: false });
  };

  /** 更改商品加入購物車的數量 */
  // 手動輸入
  handleAmount = e => {
    const { updateRequestQty } = this.props;
    const qty = e.target.value ? parseInt(e.target.value, 10) : 1;
    const productAmount = qty || 1;
    e.target.value = productAmount;
    updateRequestQty(productAmount);
    this.setState({ productAmount });
  };

  // 加減按鈕
  setAmount = type => {
    const { updateRequestQty } = this.props;
    const { productAmount } = this.state;
    if (type === 'decrement') {
      updateRequestQty(productAmount - 1);
      this.setState({ productAmount: productAmount - 1 });
    }
    if (type === 'increment') {
      updateRequestQty(productAmount + 1);
      this.setState({ productAmount: productAmount + 1 });
    }
  };

  // TODO
  /** 加入購物車Modal 刪除按鈕 */
  clearAmount = () => {
    // const {
    //   product: { rightTextInfo },
    //   // func
    //   postUpdateCart,
    // } = this.props;
    // const { productAmount } = this.state;
    // const request = {
    //   entryNumber: orderNumber,
    //   initialQuantity: productAmount,
    //   quantity: 0,
    //   productCode: rightTextInfo.sku,
    // };
    // postUpdateCart(request);
    // this.setState({ isCartModalShow: false });
  };

  /** 關閉 CartModal */
  handleModalShown = () => {
    this.setState({ isCartModalShow: false });
  };

  /** 加入購物車  & CartModal 【訂單結帳】按鈕 */
  addToCartRequestAndSend = () => {
    const {
      // request
      requestProductCode,
      requestChangePoint,
      requestQty,
      requestCatePath,
      requestDeliveryMode,
      requestDeliveryCost,
      requestAdditionalPurchases,
      // func
      postAddToCart,
    } = this.props;

    postAddToCart({
      productCode: requestProductCode,
      changePoint: requestChangePoint,
      qty: requestQty,
      catePath: requestCatePath,
      deliveryMode: requestDeliveryMode,
      deliveryCost: requestDeliveryCost,
      additionalPurchases: requestAdditionalPurchases,
    });

    this.setState({ isCartModalShow: true });
  };

  /** 立即購買 */
  instantAddToCartRequestAndSend = () => {
    const {
      // request
      requestProductCode,
      requestChangePoint,
      requestQty,
      requestCatePath,
      requestDeliveryMode,
      requestDeliveryCost,
      requestAdditionalPurchases,
      // func
      postInstantAddToCart,
    } = this.props;

    postInstantAddToCart({
      productCode: requestProductCode,
      changePoint: requestChangePoint,
      qty: requestQty,
      catePath: requestCatePath,
      deliveryMode: requestDeliveryMode,
      deliveryCost: requestDeliveryCost,
      additionalPurchases: requestAdditionalPurchases,
    });
  };

  render() {
    const {
      prdPageBrandStyle,
      product,
      isShowExceptionModal,
      apiExceptionMessage,
      addToCartResponse,
    } = this.props;
    const { isCartModalShow, productAmount, tabType } = this.state;

    return (
      <>
        {product && <Breadcrumb breadCrumb={product.apiBreadcrumb} />}

        <section className="text-primary">
          {Object.keys(product).length > 0 && (
            <article id={`product${product.rightTextInfo.sku}`} className="text-primary pt-4">
              <section id="product-info">
                <div className="container pb-5" id={product.rightTextInfo.sku}>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <ProductLightbox {...this.props} />
                    </div>
                    <div className="col-12 col-md-6">
                      <h1 className="product__heading">{product.rightTextInfo.name}</h1>
                      <Rating
                        rating={product.rightTextInfo.star}
                        reviews={product.rightTextInfo.totalReviews}
                        setTabType={this.setTabType}
                      />
                      {/* 元鍋John's */}
                      {prdPageBrandStyle == 'johns' && (
                        <ul className="product__list-short-desc mb-3">
                          {product.rightTextInfo?.shortDesc?.map((desc, i) => (
                            <li className="product__list-item-short-desc" key={`shortDesc_${i}`}>
                              {desc}
                            </li>
                          ))}
                        </ul>
                      )}

                      {/* MMM */}
                      {prdPageBrandStyle == 'mmm' && (
                        <ul className="product__list-short-desc mb-3">
                          <li>
                            <p style={{ whiteSpace: 'pre-line' }}>
                              {/* {product.rightTextInfo?.introduction?.replace(/\|/g, '\n')} */}
                              {product.rightTextInfo?.shortDesc?.map((desc, i) => {
                                if (i === 0) {
                                  return desc?.replace(/\|/g, '\n');
                                }
                              })}
                            </p>
                          </li>
                        </ul>
                      )}

                      <div id="price" className="mb-3 product__text-price-container">
                        <div className="row">
                          <div className="col-4 col-md-3">
                            <span>優惠價</span>
                            <br />
                            <span className="product__text-price text-danger">
                              NT
                              {product.rightTextInfo.secondPrice}
                              {/* {product.rightTextInfo.firstPrice} */}
                            </span>
                          </div>
                          <div className="col-4 col-md-3">
                            <span>商品售價</span>
                            <br />
                            <span className="product__text-price product__text-price-crossed">
                              NT
                              {product.rightTextInfo.firstPrice}
                            </span>
                          </div>
                          {/* 加入最愛 btn */}
                          {/* <div className="col-4 d-md-none d-flex align-items-end">
                          <AddFavorite
                            {...this.props}
                            className=""
                            isTracking={product.rightTextInfo.isTracking}
                          />
                        </div> */}
                        </div>
                      </div>
                      {product.rightTextInfo.apiStockNote ? (
                        <div className="row">
                          <button type="button" className="btn btn-outline-third col-12" disabled>
                            售完補貨中
                          </button>
                        </div>
                      ) : (
                        // TODO? TrackAndAddCartButtonWrap.jsx
                        // (
                        //   product.rightTextInfo.isNotice
                        //     ? (
                        //       <div className="row">
                        //         <button
                        //           type="button"
                        //           className="btn btn-outline-third col-12"
                        //           onClick={this.removeProductArrivalNotice}
                        //         >
                        //           補貨中，已加入到貨通知
                        //         </button>
                        //       </div>
                        //     )
                        //     : (
                        //       <div className="row">
                        //         <button
                        //           type="button"
                        //           className="btn btn-outline-third col-12"
                        //           onClick={this.addProductArrivalNotice}
                        //         >
                        //           補貨中，加入到貨通知
                        //         </button>
                        //       </div>
                        //     )
                        // )
                        <>
                          <div className="mb-3 input-group product__input-group-amount">
                            <button
                              className="btn btn-outline-third product__btn-decrease"
                              type="button"
                              onClick={() => this.setAmount('decrement')}
                              disabled={productAmount < 2}
                            >
                              -
                            </button>
                            <input
                              type="number"
                              className="form-control product__form-amount input-sm"
                              id="product-amount"
                              value={productAmount}
                              onChange={e => this.handleAmount(e)}
                            />
                            <button
                              className="btn btn-outline-third product__btn-increase"
                              type="button"
                              onClick={() => this.setAmount('increment')}
                            >
                              +
                            </button>
                          </div>
                          <ul id="campaigns" className="product__list-campaigns">
                            {product.apiDiscounts?.map((cpn, i) => (
                              // 回傳的過程可能會是 RichText，因此使用 dangerouslySetInnerHTML 處理
                              <>
                                <li
                                  key={`apiDiscounts_${i}`}
                                  className="product__list-item-campaigns"
                                  dangerouslySetInnerHTML={{ __html: cpn.title }}
                                />
                                <br />
                              </>
                            ))}
                            {product.promotionTag && (
                              <>
                                <li className="product__list-item-campaigns">
                                  {product.promotionTag}
                                </li>
                                <br />
                              </>
                            )}
                          </ul>
                          {/* <div id="coupon-buy" className="mb-3">
                              <button
                                type="button"
                                className="product__btn-coupon-buy"
                              >
                                以優惠價加購商品
                              </button>
                            </div> */}
                          <div className="row">
                            <div className="col-6">
                              <button
                                type="button"
                                className="btn btn-outline-third col-12"
                                onClick={this.addToCartRequestAndSend}
                              >
                                加入購物車
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                type="button"
                                className="btn btn-third btn__third col-12"
                                onClick={this.instantAddToCartRequestAndSend}
                              >
                                立即購買
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </section>
              <TabContent
                {...this.props}
                prdPageBrandStyle={prdPageBrandStyle}
                product={product}
                productDesc={product.descriptionUrl}
                tabType={tabType}
                setTabType={this.setTabType}
              />
              {/* 物流公告 */}
              {/* <ModalAnnounce modal /> */}
              {Object.keys(addToCartResponse).length > 0 && isCartModalShow ? (
                <AddCartModal
                  isShow={isCartModalShow}
                  product={product}
                  amount={productAmount}
                  handleModalShown={this.handleModalShown}
                  addToCartRequestAndSend={this.addToCartRequestAndSend}
                  setAmount={this.setAmount}
                  clearAmount={this.clearAmount}
                />
              ) : (
                ''
              )}
            </article>
          )}

          {/* API 回來的訊息 Modal */}
          <ApiExceptionModal
            isShowExceptionModal={isShowExceptionModal}
            apiExceptionMessage={apiExceptionMessage}
            closeExceptionModal={this.closeExceptionModal}
          />
        </section>
      </>
    );
  }
}
export default Product;
